import * as React from 'react';
require('./style.css');

interface IProps {
	text: string;
	onClick?: any;
	disabled?: boolean;
}

export const CardItemBottomButton = (props: IProps) => {
	const onViewProfileClick = (e) => {
		if (props.onClick) {
			props.onClick(e);
		}
	};

	return (
		<button
			disabled={props.disabled ? true : false}
			className="cardItemBottomButton"
			onClick={(e) => onViewProfileClick(e)}
		>
			{props.text}
		</button>
	);
};
